var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.467 10.5226C4.75841 10.2282 5.23328 10.2258 5.52765 10.5173L9.24999 14.2022L9.25001 4C9.25001 3.58578 9.5858 3.25 10 3.25C10.4142 3.25 10.75 3.58579 10.75 4L10.75 14.2022L14.4724 10.5172C14.7667 10.2258 15.2416 10.2282 15.533 10.5226C15.8244 10.817 15.822 11.2918 15.5276 11.5833L10.5276 16.533C10.2354 16.8223 9.76461 16.8223 9.47234 16.533L4.47235 11.5833C4.17799 11.2918 4.17559 10.817 4.467 10.5226Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "9b04b689432e557b2a964bb08954a258.svg";
export { ForwardRef as ReactComponent };